import React from 'react';
import './card-with-author-date-time-headline.m.css';
import CardImage from '../../atoms/cardimage';
import { get } from 'lodash';
import { formatDate, getStorySlug, getSection } from '../../../helpers/utils';
import { DATE_FORMATS } from '../../../constants';
import { BQLink } from '../../atoms/bqlink';
import { PlayIcon } from '../../atoms/material-icons';

const CardWithAuthorDateTimeHeadline = ({
  story,
  isPlayIcon = false,
  showSection = false,
  showAuthor = false
}) => {
  return (
    <BQLink href={getStorySlug(story)} styleName="search-single-result">
      <div styleName="video-thumb">
        <CardImage story={story} imageType="image16x9" aspectRatio={[16, 9]} isLazy={true} />
        {isPlayIcon ? (
          <span styleName="play-icon">
            <PlayIcon size="14px" color="#ffff" />
          </span>
        ) : null}
      </div>
      <div styleName="story-details">
        {showAuthor ? (
          <span styleName="story-details-author">{get(story, ['authors', '0', 'name'], '')}</span>
        ) : null}
        {showSection ? <span styleName="story-details-author">{getSection(story)}</span> : null}
        <span styleName="story-details-headline">{get(story, ['headline'], '')}</span>
        <span styleName="story-details-time">
          {formatDate(
            story['last-published-at'] || story['updated-at'],
            DATE_FORMATS.DATE_TIME_INDIAN
          )}
        </span>
      </div>
    </BQLink>
  );
};

export default CardWithAuthorDateTimeHeadline;
